import React from "react";
import { Card, Divider } from "antd";
import { RightOutlined } from "@ant-design/icons";
import CustomParagraph from "../../../components/CustomParagraph.jsx";

const NotificationTypeSelector = ({
  notificationTypes,
  selectedType,
  onSelect,
  hoveredCardId,
  setHoveredCardId,
}) => {
  const renderNotificationCard = (type, isSelected = false) => {
    const isHovered = hoveredCardId === type.id;

    return (
      <Card
        key={type.id}
        style={{
          boxShadow: "none",
          border: "none",
          backgroundColor: isHovered ? "#F5F5F5" : "#ffffff",
          cursor: "pointer",
          transition: "background-color 0.2s ease",
        }}
        onMouseEnter={() => setHoveredCardId(type.id)}
        onMouseLeave={() => setHoveredCardId(null)}
        onClick={() => onSelect(type.id)}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "8px 0",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
            <img
              src={type.icon}
              alt={type.label}
              style={{
                marginLeft: "6px",
                width: "24px",
                height: type.id === "CRITICAL_ALERT" ? "50px" : "24px",
                objectFit: "contain",
              }}
              onError={(e) => (e.target.style.display = "none")}
            />
            <div>
              <CustomParagraph
                color="#000"
                text={type.label}
                fontSize="14px"
                fontWeight="600"
                marginBottom={5}
              />
              <CustomParagraph
                color="#4B4B4B"
                style={{ position: "relative", top: "-2px" }}
                text={type.description}
                fontSize="12px"
                marginBottom={0}
              />
            </div>
          </div>
          <RightOutlined style={{ fontSize: "10px", color: "#000" }} />
        </div>
      </Card>
    );
  };

  return (
    <div className="custom-card-shipment">
      <CustomParagraph
        marginBottom={0}
        color="#5E5E5E"
        text="Choose a notification type"
        fontSize="14px"
      />
      {notificationTypes.map((type) => (
        <React.Fragment key={type.id}>
          {renderNotificationCard(type, selectedType?.id === type.id)}
          <Divider style={{ margin: "0px" }} />
        </React.Fragment>
      ))}
    </div>
  );
};

export default NotificationTypeSelector;
